import { ArrowRight, CircleHelp, Eye, Lightbulb } from "lucide-react";
import type { TabNarrative as TabNarrativeModel } from "../data/tabNarratives";

export default function TabNarrative({ narrative }: { narrative: TabNarrativeModel }) {
  return (
    <section className={`tab-narrative tab-narrative--${narrative.tone}`} aria-label={narrative.title}>
      <div className="tab-narrative__heading">
        <div>
          <p className="kicker">먼저 이렇게 읽으세요</p>
          <h3><Lightbulb size={17}/>{narrative.title}</h3>
        </div>
        <span className="tab-narrative__order">설명 → 근거 숫자</span>
      </div>

      <div className="tab-narrative__grid">
        <article className="tab-narrative__conclusion">
          <span><Eye size={14}/> 한줄 결론</span>
          <strong>{narrative.conclusion}</strong>
        </article>
        <article>
          <span><CircleHelp size={14}/> 왜 중요한가</span>
          <p>{narrative.importance}</p>
        </article>
        <article>
          <span><ArrowRight size={14}/> 다음 확인점</span>
          <p>{narrative.watch}</p>
        </article>
      </div>

      <div className="tab-narrative__evidence" aria-label="현재 판단의 근거 숫자">
        <b>근거 숫자</b>
        {narrative.evidence.map((item) => <span key={item}>{item}</span>)}
      </div>
      {narrative.caveat && <p className="tab-narrative__caveat">주의 · {narrative.caveat}</p>}
    </section>
  );
}
